var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.selectedExpedientTopBarData &&
    _setup.selectedExpedientTopBarData.length &&
    !_setup.showSpinner
    ? _c(
        "section",
        {
          directives: [
            {
              name: "resize",
              rawName: "v-resize",
              value: _setup.checkTruncation,
              expression: "checkTruncation",
            },
          ],
          staticClass: "expedient-global-vision-header",
        },
        [
          _c(
            "div",
            { staticClass: "first-row" },
            _vm._l(_setup.firstRowData, function (item, index) {
              return _c(
                "div",
                { key: `first-${index}`, class: [item.class, "header-item"] },
                [
                  _c("span", [_vm._v(_vm._s(item.label))]),
                  _setup.isValidData(item.data)
                    ? _c("span", { staticClass: "data" }, [
                        _vm._v(_vm._s(item.data)),
                      ])
                    : _vm._e(),
                ]
              )
            }),
            0
          ),
          _c(
            "div",
            { staticClass: "second-row" },
            _vm._l(_setup.secondRowData, function (item, index) {
              return _c(
                "div",
                { key: `second-${index + 2}`, staticClass: "header-item" },
                [
                  _c("span", { staticClass: "item-label" }, [
                    _vm._v(_vm._s(item.label)),
                  ]),
                  _setup.isValidData(item.data)
                    ? _c(
                        "span",
                        { staticClass: "data" },
                        [
                          _setup.isTruncatedItems[index]
                            ? _c(_setup.LexonTooltipComponent, {
                                attrs: {
                                  message: item.data,
                                  disabled: !_setup.isTruncatedItems[index],
                                  position: "top",
                                  isWidthAuto: "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator-element",
                                      fn: function () {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              ref: (el) =>
                                                _setup.setRef(el, index),
                                              refInFor: true,
                                              class: [
                                                "truncated",
                                                _setup.getSpecialClasses(
                                                  index + 2
                                                ),
                                              ],
                                            },
                                            [
                                              _vm._v(
                                                " " + _vm._s(item.data) + " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              })
                            : _c(
                                "span",
                                {
                                  ref: (el) => _setup.setRef(el, index),
                                  refInFor: true,
                                  class: [
                                    "truncated",
                                    _setup.getSpecialClasses(index + 2),
                                  ],
                                },
                                [_vm._v(" " + _vm._s(item.data) + " ")]
                              ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              )
            }),
            0
          ),
        ]
      )
    : _c(_setup.SpinnerLayerComponent)
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }